import { defineStore } from 'pinia'
import {constantRouterMap,asyncRouterMap} from '@/router'
import {
  generateRoutesByServer,
  flatMultiLevelRoutes
} from '@/utils/routerHelper'
import { store } from '../index'
import { cloneDeep } from 'lodash-es'

export interface PermissionState {
  routers: AppRouteRecordRaw[]
  addRouters: AppRouteRecordRaw[]
  isAddRouters: boolean
}

export const usePermissionStore = defineStore('permission', {
  state: (): PermissionState => ({
    routers: [],
    addRouters: [],
    isAddRouters: false,
  }),
  getters: {
    getRouters(): AppRouteRecordRaw[] {
      return this.routers
    },
    getAddRouters(): AppRouteRecordRaw[] {
      return flatMultiLevelRoutes(cloneDeep(this.addRouters))
    },
    getIsAddRouters(): boolean {
      return this.isAddRouters
    },
  },
  actions: {
    // generateRoutes(roles?: string[]): Promise<unknown> {
    //   return new Promise<void>((resolve) => {
    //     let routerMap: AppRouteRecordRaw[] = []
    //     routerMap = cloneDeep(asyncRouterMap)
        
    //     if (roles && roles.includes('customer')) {
    //       routerMap = this.filterCustomerRoutes(routerMap)
    //     }
        
    //     this.addRouters = routerMap.concat([
    //       {
    //         path: '/:path(.*)*',
    //         redirect: '/404',
    //         name: '404Page',
    //         meta: {
    //           hidden: true,
    //           breadcrumb: false
    //         }
    //       }
    //     ])
    //     this.routers = cloneDeep(constantRouterMap).concat(cloneDeep(this.addRouters))
    //     resolve()
    //   })
    // },
    generateRoutes(): Promise<unknown> {
      return new Promise<void>((resolve) => {
        let routerMap: AppRouteRecordRaw[] = []
        // routerMap = generateRoutesByServer(routers as AppRouteRecordRaw[])
        routerMap= cloneDeep(asyncRouterMap);
        // 动态路由，404一定要放到最后面
        this.addRouters = routerMap.concat([
          {
            path: '/:path(.*)*',
            redirect: '/404',
            name: '404Page',
            meta: {
              hidden: true,
              breadcrumb: false
            }
          }
        ])
        // 渲染菜单的所有路由
        this.routers = cloneDeep(constantRouterMap).concat(cloneDeep(this.addRouters));;
        resolve()
      })
    },



    filterCustomerRoutes(routes: AppRouteRecordRaw[]): AppRouteRecordRaw[] {
      const customerRoutes: AppRouteRecordRaw[] = []
      for (const route of routes) {
        if (route.path === '/goods') {
          const goodsRoute = cloneDeep(route)
          goodsRoute.children = goodsRoute.children?.filter(child => 
            child.path === 'wholesale'
          ) || []
          if (goodsRoute.children.length > 0) {
            customerRoutes.push(goodsRoute)
          }
        }
      }
      return customerRoutes
    },
    setIsAddRouters(state: boolean): void {
      this.isAddRouters = state
    },
  },
  persist: [
    {
      pick: ['routers'],
      storage: localStorage
    },
    {
      pick: ['addRouters'],
      storage: localStorage
    }
    // ,
    // {
    //   pick: ['isAddRouters'],
    //   storage: localStorage
    // }
  ]
})

export const usePermissionStoreWithOut = () => {
  return usePermissionStore(store)
}
